import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { LogRegister } from '../../log-register';
import { SystemLogsFilterOption } from '../../models/system-log-filter-option';
import * as SystemLogActions from '../../state/system-log-register.actions';
import { logRegisterInitialFilter } from '../../state/system-log-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-log-register',
    styleUrls: ['./account-log-register.component.scss'],
    templateUrl: './account-log-register.component.html',
    standalone: false
})
export class AccountLogRegisterComponent extends LogRegister {
   constructor(public store: Store) {
      super(store);
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: SystemLogsFilterOption[] = [
                  {
                     field: 'Account.AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = ['createUserDate', 'message', 'severityId', 'typeId', 'areaId', 'systemLogActionsMenu'];
   }
   ngOnInit() {
      this.store.dispatch(logRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(SystemLogActions.logRegisterAdapterActions.pageEnter());
   }

   onOpenDialog(event: { callLogs: any }) {
      this.store.dispatch(SystemLogActions.openDialog(event));
   }

   onOpenLogDialog(event: { callLogs: any }) {
      this.store.dispatch(SystemLogActions.openLogDialog(event));
   }
}
